import {useEffect, useState} from 'react'
import {Audit} from '../types/audit.types'

export const useAuditFilters = (audits: Audit[]) => {
  const [filteredAudits, setFilteredAudits] = useState<Audit[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [searchLength, setSearchLength] = useState(false)
  const [selectedFramework, setSelectedFramework] = useState('')

  useEffect(() => {
    setFilteredAudits(audits)
  }, [audits])

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredAudits(audits)
      setSearchLength(false)
    } else {
      const filteredItems = audits.filter(
        (audit) =>
          (typeof audit.auditTitle === 'string' && audit.auditTitle.toLowerCase().includes(searchTerm)) ||
          (Array.isArray(audit.framework) &&
            audit.framework.some(
              (fw: string) => typeof fw === 'string' && fw.toLowerCase().includes(searchTerm)
            ))
      )
      setFilteredAudits(filteredItems)
      setSearchLength(filteredItems.length === 0)
    }
  }, [audits, searchTerm])

  const handleApplyFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const status = e.target.value

    if (status === 'All') {
      setFilteredAudits(audits)
    } else {
      const filtered = audits.filter((data) => data.framework && data.framework.includes(status))
      setFilteredAudits(filtered)
    }
  }

  return {
    filteredAudits,
    searchTerm,
    setSearchTerm,
    searchLength,
    selectedFramework,
    setSelectedFramework,
    handleApplyFilter,
  }
}